export const cpa = {
  agencyCode: '999',
  name: 'Centralized Accounting and Payroll/Personnel System',
  shortName: 'CAPPS',
  slug: 'capps',
};
